export const isTest = process.env.NODE_ENV === 'test'
